<div class="gradient {{ gradient }}"></div>
